<template>
  <v-container id="obrigacoes-especiais-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <obrigacoes-especiais-tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
  import ObrigacoesEspeciaisService from '@/services/ObrigacoesEspeciaisService';
  import pusherMixins from '@/mixins/pusherMixins';
  import dayjs from 'dayjs';

  export default {
    components: {
      ObrigacoesEspeciaisTabela: () => import('@/components/obrigacoesEspeciais/Tabela.vue')
    },
    mixins: [pusherMixins],

    data() {
      return {
        items: [],
        loading: false,
        processamentosExpirados: false
      };
    },

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshObrigacoesEspeciais', () => {
          this.getAll();
        });
      },
      getAll() {
        this.loading = true;

        ObrigacoesEspeciaisService.getAll(this.processamentosExpirados)
          .then((response) => {
            this.items = [];

            response.data.oe.forEach((element) => {
              this.items.push({
                id: element.id,
                titulo: element.titulo,
                data_base: element.data_base,
                data_projetada: element.data_projetada,
                taxa_media_dep: element.taxa_media_dep,
                percentuais: JSON.parse(element.percentuais),
                possui_devolucoes: element.possui_devolucoes,
                possui_kit: element.possui_kit,
                valores: JSON.parse(element.valores),
                files: JSON.parse(element.files),
                status: element.status,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                created: element.created,
                data_processamento: element.data_processamento
                  ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm')
                  : '-'
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar as Obrigações Especiais.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
 
  